import { ReactNode } from 'react';
import Button from '@mui/material/Button';

import './outline-button.scss';

type Props = {
  icon?: ReactNode;
  label: string;
  isSelected?: boolean;
  onClick?: () => void;
};

const OutlineButton = ({ icon, label, isSelected = false, onClick }: Readonly<Props>): React.JSX.Element => (
  <Button
    className={`outlined-toggle-button ${isSelected && 'selected'}`}
    variant="outlined"
    startIcon={icon}
    onClick={onClick}
    aria-label={label}
  >
    {label}
  </Button>
);

export default OutlineButton;
